import { render, staticRenderFns } from "./DeMinimisCustomerReport.vue?vue&type=template&id=1713dcc9&scoped=true&"
import script from "./DeMinimisCustomerReport.vue?vue&type=script&lang=js&"
export * from "./DeMinimisCustomerReport.vue?vue&type=script&lang=js&"
import style0 from "./DeMinimisCustomerReport.vue?vue&type=style&index=0&id=1713dcc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713dcc9",
  null
  
)

export default component.exports